module.exports = __webpack_public_path__ + "media/images/avatar/10-2a8fefbd81eefe67e854fdc536888a07.svg";